import { takeEvery, call, all, put } from 'redux-saga/effects'
import { actions } from './MySettingsSlice'
import { notificationsEnqueue } from 'src/features/notifications/NotificationsSlice'
import { logPush } from 'src/features/contactUs/ContactUsSlice'

function* requestAccountSettingsUpdate(services, action) {
  const UserRepository = services('UserRepository')
  const Session = services('Session')
  const { payload: settings } = action

  try {
    const user = yield call([Session, 'userLoad'])
    if (!user) throw new Error('Please sign in and try again')
    yield call([UserRepository, 'saveSetting'], settings)
    yield put(actions.successAccountSettingsUpdate(settings))
  } catch (e) {
    console.log(e)
    yield put(
      notificationsEnqueue({ message: 'We were unable to save your settings.' })
    )
    yield put(
      logPush(
        'Account Settings',
        `Error while saving user settings: ${e.message}`
      )
    )
  }
}

export default function* watchUpdate(services) {
  yield all([
    takeEvery(
      actions.requestAccountSettingsUpdate,
      requestAccountSettingsUpdate,
      services
    )
  ])
}
